/**
 * @flow
 * @relayHash 9f9150ea3e948efee24ab37cf4654eab
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TaskBellUserCountsQueryVariables = {|
  userId: string
|};
export type TaskBellUserCountsQueryResponse = {|
  +userCounts: ?{|
    +pendingTasks: ?number,
    +pendingTickets: ?number,
    +upcomingCalls: ?number,
  |}
|};
export type TaskBellUserCountsQuery = {|
  variables: TaskBellUserCountsQueryVariables,
  response: TaskBellUserCountsQueryResponse,
|};
*/


/*
query TaskBellUserCountsQuery(
  $userId: ID!
) {
  userCounts(userId: $userId) {
    pendingTasks
    pendingTickets
    upcomingCalls
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "userCounts",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "UserCounts",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pendingTasks",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pendingTickets",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "upcomingCalls",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TaskBellUserCountsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "TaskBellUserCountsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "TaskBellUserCountsQuery",
    "id": null,
    "text": "query TaskBellUserCountsQuery(\n  $userId: ID!\n) {\n  userCounts(userId: $userId) {\n    pendingTasks\n    pendingTickets\n    upcomingCalls\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '73036ac3f30e4759eedbfb6aaa42796e';
module.exports = node;
